import { useState } from 'react'
import type { CustomsBrokerDto } from '@crm/shared'
import { BrokerCardModal } from './BrokerCardModal'
import { useCustomsBrokers } from './useCustomsBrokers'

const NEW_BROKER = '__new__'

interface Props {
  value: string | null
  onChange: (brokerId: string | null) => void
  disabled?: boolean
  id?: string
  /** Брокер запроса, скрытый в справочнике: показать его в списке, чтобы выбор не «потерялся». */
  current?: { id: string; name: string } | null
}

/**
 * Выбор брокера: «не указан», брокеры справочника и «+ Новый брокер…» — карточку
 * заводят прямо отсюда, без ухода со страницы (справочник наполняется работой).
 */
export function BrokerSelect({ value, onChange, disabled, id, current }: Props) {
  const brokers = useCustomsBrokers()
  const [creating, setCreating] = useState(false)
  const list: Array<Pick<CustomsBrokerDto, 'id' | 'name'>> = brokers.data ?? []
  const withCurrent = current && !list.some((b) => b.id === current.id) ? [...list, current] : list

  return (
    <>
      <select
        id={id}
        value={value ?? ''}
        disabled={disabled || brokers.isLoading}
        onChange={(e) => {
          const v = e.target.value
          if (v === NEW_BROKER) setCreating(true)
          else onChange(v || null)
        }}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm bg-white focus:outline-none focus:ring-2 focus:ring-brand-500 disabled:opacity-60"
      >
        <option value="">
          {brokers.isLoading ? 'Загружаю брокеров…' : '— брокер не указан —'}
        </option>
        {withCurrent.map((b) => (
          <option key={b.id} value={b.id}>
            {b.name}
          </option>
        ))}
        <option value={NEW_BROKER}>+ Новый брокер…</option>
      </select>
      {creating && (
        <BrokerCardModal
          onClose={() => setCreating(false)}
          onSaved={(saved) => onChange(saved.id)}
        />
      )}
    </>
  )
}
